<template>
  <div v-if="is">
    <slot />
  </div>
</template>

<script>
import mx from './mx.vue';
export default {
  mixins: [mx],
  computed: {
    is(){
        if(this.mx_is && this.$context.is.align) return true;
        if(this.mx_is && this.mx_isMultipleIncremental){
          const isProrated = this.mx_cartPlan.cartInfo?.selected_number > (this.mx_boughtPlan?.cartInfo?.selected_number??0);
          // For support coupon case: show previously bought plans even if license count didn't change
          // This prevents hiding existing regions when adding a new region with support coupon applied
          if(this.mx_prorated4SupportedCouponCase && this.mx_boughtPlan?.cartInfo?.selected_number > 0){
            return true;
          }
          return isProrated ? true : false;
        };
        return true;
    },
  },
};
</script>
